import { useUser } from "../contexts/UserContext";
import ProfileView from "../components/ProfileView";
export default function Profile() {
  const { currentUser } = useUser();
  return <ProfileView uid={currentUser?.uid} />;
}
